import { CalendarMonth, Person, Tune } from '@mui/icons-material'
import { BottomNavigationAction } from '@mui/material'
import { StyledBottomNavigation } from 'candidate/components/Sidebar/Styles'
import { candidateRouteConfig } from 'candidate/routes'
import { useLocation, useNavigate } from 'react-router-dom'

import type { BottomNavigationOwnProps } from '@mui/material'

export function BottomNavigation() {
    const location = useLocation()
    const navigate = useNavigate()

    const handleBottomNavChange: BottomNavigationOwnProps['onChange'] = (
        _event,
        newValue
    ) => {
        navigate(newValue)
    }

    return (
        <StyledBottomNavigation
            onChange={handleBottomNavChange}
            showLabels
            value={location.pathname}
        >
            <BottomNavigationAction
                label="Preferences"
                icon={<Tune />}
                value={candidateRouteConfig.preferences.path}
            />
            <BottomNavigationAction
                label="Schedule"
                icon={<CalendarMonth />}
                value={candidateRouteConfig.schedule.path}
            />
            <BottomNavigationAction
                label="Profile"
                icon={<Person />}
                value={candidateRouteConfig.profile.path}
            />
        </StyledBottomNavigation>
    )
}
